import React, { useEffect, useState } from "react";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";

const Header = () => {

  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    let userDetails = getAuthProps()
    setUserDetails(userDetails)
  }, [])

  return (
    <>
      <header className="sticky top-0 bg-white z-30 px-[30px] py-5 text-[16px] font-medium text-[#223645] justify-items-end" style={{ borderBottom: "1px solid rgb(0,0,0,0.1)", boxShadow: "0 2px 12px rgb(14, 63, 126, 0.04)", lineHeight: "16px" }}>
        <p className="header-inner flex items-center gap-2.5 text-right m-0">
          <FontAwesomeIcon icon={faCircleUser} className="w-[20px] h-[20px]" />
          {userDetails.firstName ?
            (userDetails.firstName + " " + userDetails.lastName)
            : null}
        </p>
      </header>
    </>
  );
};

export default Header;
